import { render, staticRenderFns } from "./ContractWidgetNftSale.vue?vue&type=template&id=66283bd8&"
import script from "./ContractWidgetNftSale.vue?vue&type=script&lang=js&"
export * from "./ContractWidgetNftSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports